<template>
  <b-container>
    <home />
    <mold-mildew />
    <crawlspaces />
    <h-v-a-c />
    <about />
    <contact />
  </b-container>
</template>

<script>
import Home from './Home.vue'
import About from './About.vue'
import Contact from './Contact.vue'
import Crawlspaces from './Crawlspaces.vue'
import HVAC from './HVAC.vue'
import MoldMildew from './MoldMildew.vue'
export default {
  components: {
    Home,
    About,
    Contact,
    Crawlspaces,
    HVAC,
    MoldMildew
  }
}
</script>

<style>

</style>
